/**
 * Copies given text to the user's system clipboard.
 * @param text - text that will be copied
 */
export default function copyToClipboard(text) {
    return new Promise(resolve => {
        if (!navigator?.clipboard?.writeText)
            resolve(false);
        navigator.clipboard.writeText(`${text}`).then(() => resolve(true), error => {
            console.error(error);
            resolve(false);
        });
    });
}
